import { Box, CircularProgress } from '@mui/material';
import React from 'react'

function CouponLoader() {
    return (
        <Box className='coupon-loader'>
          <CircularProgress />
        </Box>
      );
}

export default CouponLoader